export const ConnectionSettingsF3busPlugin: IPluginSettings = {
  name: "Настройка соединения F3BUS",
  mnemocode: 'connection_settings_f3bus_plugin',
  permission: 'Goods',
  columns: [
    {
      order: 0,
      propertyName: 'id',
      propertyType: 'number',
      displayName: 'id',
      visibility: true,
      width: 80
    },
    {
      order: 1,
      propertyName: 'name',
      propertyType: 'string',
      displayName: 'name',
      visibility: true,
      width: 180
    },
    {
      order: 2,
      propertyName: 'login',
      propertyType: 'string',
      displayName: 'login',
      visibility: true,
      width: 150
    },
    {
      order: 3,
      propertyName: 'email',
      propertyType: 'string',
      displayName: 'email',
      visibility: true,
      width: 200
    },
    {
      order: 4,
      propertyName: 'phone',
      propertyType: 'string',
      displayName: 'phone',
      visibility: true,
      width: 140
    },
    {
      order: 5,
      propertyName: 'description',
      propertyType: 'string',
      displayName: 'description',
      visibility: true,
      width: 240
    },
    {
      order: 6,
      propertyName: 'website',
      propertyType: 'string',
      displayName: 'website',
      visibility: true,
      width: 200
    },
    {
      order: 7,
      propertyName: 'apiVer',
      propertyType: 'string',
      displayName: 'apiVer',
      visibility: true,
      width: 100
    },
    {
      order: 8,
      propertyName: 'inn',
      propertyType: 'string',
      displayName: 'inn',
      visibility: true,
      width: 130
    },
    {
      order: 9,
      propertyName: 'kpp',
      propertyType: 'string',
      displayName: 'kpp',
      visibility: true,
      width: 120
    },
    {
      order: 10,
      propertyName: 'prefixInvoiceOrder',
      propertyType: 'string',
      displayName: 'prefixInvoiceOrder',
      visibility: true,
      width: 180
    },
    {
      order: 11,
      propertyName: 'postfixInvoiceOrder',
      propertyType: 'string',
      displayName: 'postfixInvoiceOrder',
      visibility: true,
      width: 180
    },
  ]
}
